<template>

  <div v-if="!activeUser.admin && activeUser.site && activeUser.site.hasDataProcessingConfirmed === false">

    <data-processing-modal></data-processing-modal>

  </div>

  <div v-else>
    <component :is="currentComponent"></component>
  </div>

</template>

<script>
import dataProcessingModal from '../utils/dataProcessingModal'

export default {

    components: {
      dataProcessingModal,
      'newsletter': () => import('@/components/newsletter/NewsletterList'),
      'siteNewsletter': () => import('@/components/newsletter/siteNewsletter'),
    },

    computed: {

      currentComponent() {
          return this.activeUser && this.userRole == 'Administrator' ? 'newsletter' : 'siteNewsletter';
      }

    }

}
</script>
